import { render } from "./CarouselA.vue?vue&type=template&id=fb2a081e&scoped=true"
import script from "./CarouselA.vue?vue&type=script&lang=js"
export * from "./CarouselA.vue?vue&type=script&lang=js"

import "./CarouselA.vue?vue&type=style&index=0&id=fb2a081e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb2a081e"]])

export default __exports__